export enum FORM_TEXT_TYPES {
  EMAIL = 'EMAIL',
  NAME = 'NAME',
  POSTCODE = 'POSTCODE',
  CREATE_PET = 'CREATE_PET'
}

export const FORM_TEXT_COMPONENT_TYPES = {
  EMAIL: {
    title: 'formTextTypes.email.title',
    registerAs: 'email',
    requiredMessage: 'formTextTypes.email.requiredMessage',
    pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    patternMessage: 'formTextTypes.email.patternMessage',
    placeholder: 'formTextTypes.email.placeholder'
  },
  NAME: {
    title: 'formTextTypes.name.title',
    registerAs: 'name',
    requiredMessage: 'formTextTypes.name.requiredMessage',
    pattern: /.{2,}/,
    patternMessage: 'formTextTypes.name.patternMessage',
    placeholder: 'formTextTypes.name.placeholder'
  },
  POSTCODE: {
    title: 'formTextTypes.postcode.title',
    registerAs: 'postcode',
    requiredMessage: 'formTextTypes.postcode.requiredMessage',
    pattern: /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/i,
    patternMessage: 'formTextTypes.postcode.patternMessage',
    placeholder: 'formTextTypes.postcode.placeholder'
  },
  CREATE_PET: {
    title: 'formTextTypes.createPet.title',
    registerAs: 'newPet',
    requiredMessage: 'formTextTypes.createPet.requiredMessage',
    pattern: /.{2,}/,
    patternMessage: 'formTextTypes.createPet.patternMessage',
    placeholder: 'formTextTypes.createPet.placeholder'
  }
} as const;
